import { useContext, useMemo } from 'react'
import RootStore, { $RootStore } from '../../stores/RootStore'
import { NavigateFunction, useNavigate } from 'react-router'

export function useVM<T>(VM: new (store: $RootStore, navigate: NavigateFunction) => T): T {
  const store = useContext(RootStore)
  const navigate = useNavigate()

  const vm = useMemo(() => {
    const viewModel = new VM(store, navigate)
    return viewModel
  }, [VM, store, navigate])

  return vm
}